import React from "react";
import axiosInstance from "../utils/axiosInstance";
import '@css/Header.css'
import { clearUserInfo } from "@utils/commonFunctions";
import store from '@store/store';
import CrudButtons from "@components/CrudButtons";
import TokenTimer from "@components/TokenTimer";


export default function Header({ onClickCompanySelect, pageAuth, envName }) {

    const userInfo = localStorage.getItem('userInfo');
    const user = userInfo ? JSON.parse(userInfo) : null;
    const isAdmin = user?.userName === '시스템관리자'


    return (
        <>
            <header className="navbar navbar-expand-lg justify-content-end align-items-center header" style={{height: '2%', position: 'relative'}}>
                {/* 환경명 표시: 시간 왼쪽 */}
                {envName && envName.trim().toLowerCase() !== 'live server' && (
                  <div style={{
                    display: 'inline-block',
                    marginRight: 20,
                    fontWeight: 'bold',
                    fontSize: 20,
                    color: envName === 'TEST SERVER' ? '#1976d2' : '#388e3c',
                    background: envName === 'TEST SERVER' ? 'rgba(25, 118, 210, 0.08)' : 'rgba(56, 142, 60, 0.08)',
                    padding: '6px 18px',
                    borderRadius: 16,
                    boxShadow: '0 1px 4px rgba(25,118,210,0.08)',
                    letterSpacing: 2,
                    verticalAlign: 'middle',
                  }}>
                    {envName}
                  </div>
                )}
                <TokenTimer/>
                <CrudButtons permissions={pageAuth} />

                <div className="dropdown">
                    <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <span>
                            {localStorage.getItem('userInfo') !== null
                                ? JSON.parse(localStorage.getItem('userInfo')).userName
                                : "시스템관리자"
                            }
                        </span>
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end">
                        {isAdmin && (
                            <>
                                <li><a className="dropdown-item" id="company-select" onClick={onClickCompanySelect}>업체 선택</a></li>
                                <li><a className="dropdown-item" id="company-management">업체 관리</a></li>
                            </>
                        )}
                        <li><a className="dropdown-item">사용자 매뉴얼</a></li>
                        <li><a className="dropdown-item">환경설정</a></li>
                        <li>
                            <a className="dropdown-item logout" onClick={() => clearUserInfo(store.dispatch)}>로그아웃</a>
                        </li>
                    </ul>
                </div>

            </header>
        </>
    )

}